import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import { Pill, Loading } from '@myxplor/ui'

import ActiveFilter from '../../../../ui/active-filter'
import { recordActionsToDisplay } from '../../../../ui/gov-actions'
import RecordDisplayList from '../../../../ui/record-display-list'

import { active as activeFilter } from '../filter'
import Empty from './empty'
import Merge from '../../merge'
import migrateToXplor from '../migrate-to-xplor'
import cancelEnrolment from '../cancel-enrolment'
import cancelSubmissions from '../cancel-submissions'

const ensureArray = record => {
  return record instanceof Array ? record : [record]
}

const ConditionalPill = ({ condition, children }) => {
  return condition && 'N' !== condition ? (
    <li>
      <Pill>{children}</Pill>
    </li>
  ) : null
}

const GovRecordBadges = ({ record }) => (
  <Fragment>
    <h4>ID: {record.gov_record.FaCSIAEnrolmentId}&nbsp;</h4>
    <ul>
      <li>
        <Pill>{record.gov_record.Type}</Pill>
      </li>
      <li>
        <Pill>{record.gov_record.Status}</Pill>
      </li>
      <ConditionalPill condition={['ASC', 'BSC', 'VAC'].includes(record.gov_record.ServiceType)}>
        {record.gov_record.ServiceType}
      </ConditionalPill>
      <ConditionalPill condition={'Y' === record.gov_record.ChildSpecialNeeds}>
        Special Needs
      </ConditionalPill>
      <ConditionalPill condition={'Y' === record.gov_record.JFAEligibilityDetailsRequest}>
        JET
      </ConditionalPill>
      <ConditionalPill condition={'Y' === record.gov_record.ChildDisability}>
        Disability
      </ConditionalPill>
    </ul>
  </Fragment>
)

const actionsForRecord = ({ record }) => [
  migrateToXplor({ record }),
  cancelEnrolment({ record }),
  cancelSubmissions({ record }),
]

const defaultState = {
  status: null,
}

const childName = ({ ChildFirstName, ChildMiddleName, ChildLastName }) =>
  [ChildFirstName, ChildMiddleName, ChildLastName].filter(val => val).join(' ')

const parentName = ({ ParentGuardianFirstName, ParentGuardianLastName }) =>
  [ParentGuardianFirstName, ParentGuardianLastName].filter(val => val).join(' ')

export class GovEnrolmentsView extends Component {
  constructor(props) {
    super(props)
    this.state = props.merge || defaultState
  }

  mergePending(state) {
    this.setState({
      status: 'pending',
      ...state,
    })
  }

  mergeFailed() {
    this.setState({
      status: 'failed',
    })
  }

  mergeCompleted() {
    this.setState(defaultState)
  }

  render() {
    const { loading, data = [], connectDropTarget, canDrop, isOver } = this.props

    if (loading) return <Loading>Loading matching CCMS Government Enrolments</Loading>

    return connectDropTarget(
      <div
        className={classnames({
          'recordDisplayList--wrapper': true,
          drop__canDrop: canDrop,
          drop__isOver: isOver,
        })}>
        {data.length === 0 ? (
          <Empty>
            <Merge {...this.state} />
          </Empty>
        ) : (
          this.displayEnrolments(data)
        )}
      </div>
    )
  }

  displayEnrolments(data) {
    return (
      <ActiveFilter records={ensureArray(data)} filterOn={activeFilter}>
        <RecordDisplayList
          name="CCMS Government Enrolment"
          recordBadgesComponent={GovRecordBadges}
          actionButtonsComponent={recordActionsToDisplay({
            actionsForRecord,
          })}
          topContent={<Merge {...this.state} />}
          showRaw
          recordBase="gov_record"
          level1={[
            {
              label: 'Child',
              fn: childName,
            },
            {
              key: 'ChildCRN',
              label: 'Child CRN',
            },

            {
              label: 'Parent',
              fn: parentName,
            },
            {
              key: 'ParentGuardianCRN',
              label: 'Parent CRN',
            },
          ]}
          level2={[
            {
              key: 'YTDAbsences',
              label: 'YTD absences',
            },
            {
              key: 'CCBPercentage',
              label: 'CCB Percentage',
            },

            {
              key: 'CCBEligibleHours',
              label: 'CCB eligible hours',
            },
            {
              key: 'CCBType',
              label: 'CCB type',
            },
            {
              key: 'CCBMethod',
              label: 'CCB method',
            },
            {
              key: 'CCBParentChildStatus',
              label: 'CCB parent child status',
            },
            {
              key: 'CCRMethod',
              label: 'CCR method',
            },
            {
              key: 'RequestEnrolmentAdvance',
              label: 'Request enrolment advance',
            },
            {
              key: 'StartDate',
              label: 'Start date',
            },
            {
              key: 'FormalisedDate',
              label: 'Formalised date',
            },
            {
              key: 'CCBDetailsUpdated',
              label: 'CCB details updated',
            },
            {
              key: 'ChildDateOfBirth',
              label: 'Child date of birth',
            },
            {
              key: 'ParentGuardianDateOfBirth',
              label: 'Parent date of birth',
            },
            {
              key: 'ChildServiceClientId',
              label: 'Child Service Client Id',
            },
          ]}
        />
      </ActiveFilter>
    )
  }
}

export default GovEnrolmentsView



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/views/index.jsx